// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ea8bf1e7","239":"d44b0346","455":"6e66fc00"}[chunkId] + ".chunk.js";
};